import { render } from "./Shortcuts.vue?vue&type=template&id=32cc7924&scoped=true&ts=true&lang=pug"
import script from "./Shortcuts.vue?vue&type=script&lang=ts"
export * from "./Shortcuts.vue?vue&type=script&lang=ts"

import "./Shortcuts.vue?vue&type=style&index=0&id=32cc7924&scoped=true&lang=css"

import exportComponent from "/builds/checkmeru/renova-telemedicine/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32cc7924"]])

export default __exports__